'use client';

import { DRIFT_CUSTOM_WALLET_ICONS } from 'src/constants/wallets';
import { DriftTheme } from 'src/environmentVariables/EnvironmentVariableTypes';
import useDriftTheme from 'src/hooks/useDriftTheme';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

const useCurrentWalletIconSrc = () => {
	const walletState = useDriftStore((s) => s.wallet);

	const isLightTheme = useDriftTheme() === DriftTheme.light;

	if (walletState.isAppKit)
		return isLightTheme
			? DRIFT_CUSTOM_WALLET_ICONS.APPKIT_WALLET_ADAPTER.light
			: DRIFT_CUSTOM_WALLET_ICONS.APPKIT_WALLET_ADAPTER.dark;

	if (walletState.isMagicAuth) {
		return DRIFT_CUSTOM_WALLET_ICONS.MAGIC_AUTH_WALLET_ADAPTER;
	}

	if (walletState.isPrivyNativeAuth) {
		return isLightTheme
			? DRIFT_CUSTOM_WALLET_ICONS.PRIVY_NATIVE_WALLET_ADAPTER.light
			: DRIFT_CUSTOM_WALLET_ICONS.PRIVY_NATIVE_WALLET_ADAPTER.dark;
	}

	return walletState?.current?.adapter?.icon;
};

export default useCurrentWalletIconSrc;
